 import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import auth from "../redux/actions/auth";

import { FiLogOut } from "react-icons/fi";
// import {
//   getCurrentUser,
//   removeToken,
//   removeCurrentUser,
//   isAuthenticated,
// } from "../redux/actions/auth";

const navItems = [
  { label: "Accueil", path: "/accueil", icon: "🏠" },
  { label: "Quizz", path: "/quizz", icon: "📄" },
  { label: "Pratique", path: "/pratique", icon: "📝" },
  { label: "Evaluation", path: "/Evaluation", icon: "🧪" },
  { label: "Score", path: "/score", icon: "🏆" },
  { label: "Leaderboard", path: "/leaderboard", icon: "📊" },
];

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isAuth, setIsAuth] = useState(false);

  // console.log("auth object:", auth);
  // console.log("auth.logout:", auth.logout);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await auth.isAuthenticated(); // ✅ appel asynchrone correct
      setIsAuth(result);

      if (!result) {
        navigate("/login", { replace: true }); // 🔁 redirection si pas connecté
      }
    };

    checkAuth();
  }, [location.pathname, navigate]);
  // Se déclenche seulement quand l'URL change

  const handleLogout = async () => {
    try {
      await auth.logout(navigate); // ✅ maintenant ça marche
    } catch (err) {
      // console.error("Erreur de déconnexion :", err);
    }
  };

  const closeMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setMenuOpen(false);
      setIsClosing(false);
    }, 300);
  };

  const toggleMenu = () => {
    if (menuOpen) {
      closeMenu();
    } else {
      setMenuOpen(true);
    }
  };

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm z-50 w-full sticky top-0">
      <div className="flex items-center justify-between h-[75px] px-6 sm:px-8 lg:px-12">
        {/* Logo */}
        <div
          onClick={() => navigate("/accueil")}
          className="flex items-center justify-center h-full cursor-pointer"
        >
          <span className="text-[#FFA000] text-3xl sm:text-4xl font-bold leading-none">
            &lt;&gt;
          </span>
        </div>

        {/* Menu desktop */}
        <div className="flex-1 flex items-center justify-center">
          <div className="hidden md:flex gap-2">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <NavLink
                  to={item.path}
                  key={item.path}
                  className={`group relative flex flex-col items-center justify-center text-sm font-medium px-2 py-1 transition-all duration-200 no-underline ${
                    isActive
                      ? "text-[#FFA000] font-semibold"
                      : "text-gray-800 hover:text-[#FFA000]"
                  }`}
                  style={{ textDecoration: "none" }}
                >
                  <span
                    className={`absolute text-xl text-[#FFA000] transition-all duration-300 ease-in-out
                  ${isActive ? "opacity-100 -translate-y-4" : "opacity-[0]"}
                  ${
                    !isActive
                      ? "group-hover:opacity-100 group-hover:-translate-y-4"
                      : ""
                  }
                `}
                  >
                    {item.icon}
                  </span>
                  <span className="pt-2 text-sm h-6 w-[90px] text-center transition-transform duration-300 ease-in-out group-hover:scale-105">
                    {item.label}
                  </span>
                </NavLink>
              );
            })}
          </div>

          {/* Burger (mobile) */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-2xl text-gray-700 focus:outline-none ms-[35px]"
            >
              {menuOpen ? "✖️" : "☰"}
            </button>
          </div>
        </div>

        {/* Déconnexion */}
        <div className="flex items-center justify-center px-1 sm:px-3">
          {isAuth && (
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-2 sm:px-3 py-2 rounded-md bg-[#009688] hover:bg-[#185750] text-white text-sm font-medium transition duration-200 whitespace-nowrap"
            >
              <FiLogOut className="text-base" />
              <span className="hidden lg:inline">Déconnexion</span>
            </button>
          )}
        </div>
      </div>

      {/* Menu mobile */}
      {(menuOpen || isClosing) && (
        <div
          className={`flex flex-col items-center gap-4 px-4 py-6 md:hidden bg-white border-t border-gray-100 ${
            isClosing ? "animate-fade-out" : "animate-fade-in"
          }`}
        >
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={closeMenu}
              className={({ isActive }) =>
                `group flex flex-col items-center justify-center text-sm font-medium px-4 py-2 w-full rounded-md transition-colors duration-200 ${
                  isActive
                    ? "text-[#FFA000] font-semibold bg-gray-100"
                    : "text-gray-800 hover:text-[#FFA000] hover:bg-gray-50"
                }`
              }
              style={{ textDecoration: "none" }}
            >
              <span className="text-xl mb-1 text-[#FFA000] group-hover:-translate-y-1 transition-transform">
                {item.icon}
              </span>
              <span className="leading-none">{item.label}</span>
            </NavLink>
          ))}

          {/* {isAuth && (
            <button
              onClick={() => {
                handleLogout();
                closeMenu();
              }}
              className="flex items-center gap-2 text-red-600 hover:text-red-800 transition"
            >
              <FiLogOut className="text-lg" />
              Déconnexion
            </button>
          )} */}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
